import { Action, Dispatch } from 'redux';
import { getExchangeInfoFiles } from '../../api/vault/assets/api';
import { IAppState } from '../reducers';

export interface IExchangeInfoFile {
  name: string,
  url: string,
}
export interface IState {
  isLoading: boolean;
  isOpen: boolean;
  infoFiles: IExchangeInfoFile[];
}

export enum ActionType {
 Toggle = 'ExchangeInfo.Toggle',
 Clear = 'ExchangeInfo.Clear',
 Hydrate = 'ExchangeInfo.Hydrate',
 Loading = 'ExchangeInfo.Loading'
}

export interface IExchangeInfoAction extends Action<ActionType> {
    payload?: any,
}

const INITIAL_STATE: IState = {
  isLoading: false,
  isOpen: false,
  infoFiles: null,
};

export const clearExchangeInfo = () => async (
  dispatch: Dispatch,
) => {
  dispatch({
    type: ActionType.Clear,
  });
};

export const toggleExchangeInfo = () => async (
  dispatch: Dispatch,
) => {
  dispatch({
    type: ActionType.Toggle,
  });
};

const manageExchangeInfoLoading = (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const { isLoading } = getState().exchange.exchangeInfo;

  if (!isLoading) {
    dispatch({
      type: ActionType.Loading,
      payload: true,
    });
  } else {
    dispatch({
      type: ActionType.Loading,
      payload: false,
    });
  }
};

export const hydrateExchangeInfo = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  manageExchangeInfoLoading(dispatch, getState);

  const response = await getExchangeInfoFiles();

  dispatch({
    type: ActionType.Hydrate,
    payload: response.data,
  });

  manageExchangeInfoLoading(dispatch, getState);
};

export default function reducer(state: IState = INITIAL_STATE, action: IExchangeInfoAction): IState {
  switch (action.type) {
    case ActionType.Clear:
      return INITIAL_STATE;
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.Hydrate:
      return {
        ...state,
        infoFiles: action.payload,
      };
    case ActionType.Loading:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
